import * as React from "react";
import * as ReactDOM from 'react-dom';
import { IExplorerProperties, IFundFilterResponse, IShareClassFilterResponse } from "../../../models";
const styles = require('./MiniFilter.pcss');
const FaAngleDown = require('react-icons/lib/fa/angle-down');
import { ExplorerTabDailyPrices, ExplorerTabPerformance, ExplorerTabCharges, ExplorerTabYield } from "../../FundExplorerTabs";
import { BASE_SEARCH_REQUEST } from "../../../data";
import { ITypeahead } from '../../../models/application';
import { sentenceCase } from "change-case";

interface IProps {
    styles?: Object;
    type: string;
    filterData?: string[];
    selectedItem?: string;
    selectFn?: Function;
}

interface IState {
    visible?: boolean;
}

let body = document.querySelector("body");

export class MiniFilter extends React.Component<IProps & IExplorerProperties, IState>{

    constructor(props) {
        super(props)
        this.state = { visible: false };
        this.toggle = this.toggle.bind(this);
        this.handleDocumentClick = this.handleDocumentClick.bind(this);
        this.selectItemAndClose = this.selectItemAndClose.bind(this);
    }

    toggle() {
        this.setState({ visible: !this.state.visible }, () => {
            this.handleProps();
        });
    }

    componentWillMount() {
        this.handleProps();
    }

    handleProps() {
        if (this.state.visible) {
            this.addEvents();
        } else {
            this.removeEvents();
        }
    }

    addEvents() {
        document.addEventListener('click', this.handleDocumentClick, true);
    }

    removeEvents() {
        document.removeEventListener('click', this.handleDocumentClick, true);
    }

    handleDocumentClick(e) {
        const container = ReactDOM.findDOMNode(this);

        if (container.contains(e.target) && container !== e.target) {
            return;
        }

        this.toggle();
    }

    selectItemAndClose(event, type, item) {
        let { selectFn } = this.props;
        selectFn(type, item);
        this.toggle();
    }

    render() {
        let visibility = this.state.visible ? styles.active : '';
        let internalClasses = {
            dropdown: `${ styles.dropdown } ${ visibility }`,
            arrow: `${ styles.arrow } ${ visibility }`
        };
        let { type, filterData, selectedItem,  } = this.props;

        return (
            <div className={ styles.filterWrapper } >
                <div className={ styles.filterButton } onClick={ this.toggle }>
                    { selectedItem === "" ? type === "shareclass_letter" ? "Share class" : sentenceCase(type) : selectedItem } <div><FaAngleDown /></div>
                </div>

                <section className={ internalClasses.dropdown }>
                    <div className={ styles.options }>
                        <ul>
                            { filterData.sort().map((item, index) => (
                                <li key={ index } onClick={ (event) => this.selectItemAndClose(event, type, item) }>{ item }</li>
                            )) }
                        </ul>
                    </div>
                </section>
            </div>
        );
    }
}




// WEBPACK FOOTER //
// ./src/client/components/MiniFundFinder/MiniFilter/MiniFilter.tsx